import i18n from 'modules/core/lib/i18n'

export const cotizationGroups = () => [
  {
    value: 1,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.1'
    ),
  },
  {
    value: 2,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.2'
    ),
  },
  {
    value: 3,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.3'
    ),
  },
  {
    value: 4,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.4'
    ),
  },
  {
    value: 5,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.5'
    ),
  },
  {
    value: 6,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.6'
    ),
  },
  {
    value: 7,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.7'
    ),
  },
  {
    value: 8,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.8'
    ),
  },
  {
    value: 9,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.9'
    ),
  },
  {
    value: 10,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.10'
    ),
  },
  {
    value: 11,
    label: i18n.t(
      'contract_versions.forms.contract_extra_information.es_cotization_group_options.11'
    ),
  },
]
